import UnidadeService from '@/services/UnidadeService';

export const unidade = {
    namespaced: true,
    actions: {
        newUnidade(){
            return UnidadeService.newUnidade();
        },
        getAllUnidade () {
            return UnidadeService.getAllUnidade()
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        getUnidade ({id}) {
            return UnidadeService.getUnidade(id)
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        postUnidade ({payload}) {
            return UnidadeService.postUnidade(payload)
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        postUnidadeRetornar ({dispatch}, payload) {
            return UnidadeService.postUnidadeRetornar(payload)
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        putUnidade ({dispatch}, payload) {
            return UnidadeService.putUnidade(payload)
            .then(
                response => {
                    return response;
                },
                error => {
                    console.error(error);
                    return Promise.reject(new Error(error));
                }
            );
        },
        deleteUnidade ({dispatch}, id) {
            return UnidadeService.deleteUnidade(id)
            .then(
                response => {
                    return response;
                },
                error => {
                    console.error(error);
                    return Promise.reject(new Error(error));
                }
            );
        },
    },
    state: {},
    mutations: {},
};
